<div class="info">
  <h1>{{ config().title }}</h1>
  @if (config().description.lines.length > 0) {
    <lsa-description-block
      [descriptionBlockConfig]="config().description!"
    ></lsa-description-block>
  }
</div>

<div class="calendar-events-container">
  @for (
    calendarEvent of calendarEventService.calendarEventList();
    track calendarEvent
  ) {
    <mat-card class="calendar-card" appearance="outlined">
      <mat-card-header>
        <mat-card-title>
          {{ calendarEvent.title }}
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <p>{{ calendarEvent.description }}</p>
        <table class="table-info">
          @if (calendarEvent.allDay) {
            <tr>              
              <td [innerHTML]="getFormattedDateRange(calendarEvent.start, calendarEvent.end)">
              </td>
            </tr>    
          } @else {
            <tr>
              <td>Inicio:</td>
              <td>
                <b class="capitalize-text">{{ calendarEvent.start | date: "MMMM d, y hh:mm a" : "" : "es" }}</b>
              </td>
            </tr>

            @if (calendarEvent.end) {
              <tr>
                <td>Fin:</td>
                <td>
                  <b class="capitalize-text">{{ calendarEvent.end | date: "MMMM d, y hh:mm a" : "" : "es" }}</b>
                </td>
              </tr>
            }
          }
        </table>
      </mat-card-content>
    </mat-card>
  } @empty {
    @if (calendarEventService.loading()) {
      <mat-spinner></mat-spinner>
    } @else {
      <p>En este momento no hay ningún evento agendado</p>
    }
  }
</div>
